import React from "react";
import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ReactComponent as RightArrowIcon } from "../../assets/svg/right-arrow.svg";

import { ErrorMessage } from "./styles";
import { fontWeights, sizes } from "../../constant/styles";
import { ERROR_500 } from "../../constant/colors";

/**
 * Inline banner shown when a patient is missing required contact details for a Redi link.
 * Reuses the existing ErrorMessage style and appends an "Add →" action on the right.
 *
 * @param {string}   [props.id]    - Optional element id for testing/tracking
 * @param {Function} props.onAdd   - Called when the user clicks "Add →"
 */
const RediMissingContactBanner = ({ id, onAdd }) => {
  const { t } = useTranslation();

  return (
    <ErrorMessage id={id} style={{ justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <ExclamationCircleOutlined />
        {t("redi.invitation_modal.missing_contact_title")}
      </div>

      {onAdd && (
        <Button
          type="link"
          danger
          size="small"
          onClick={onAdd}
          style={{
            padding: 0,
            height: "auto",
            fontSize: sizes.small,
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontWeight: fontWeights.semibold,
            color: ERROR_500
          }}
        >
          {t("redi.invitation_modal.add_contact")}
          <RightArrowIcon style={{ width: 12, height: "auto", flexShrink: 0 }} />
        </Button>
      )}
    </ErrorMessage>
  );
};

export default RediMissingContactBanner;
